import React, {
  useState,
  createContext,
  useCallback,
  useContext,
  useLayoutEffect
} from 'react';
import PropTypes from 'prop-types';
import LoadingOverlay from 'components/LoadingOverlay';

const Context = createContext(() => {});

// Shows loading overlay until WaterfallLoadingHider element is rendered
export const WaterfallLoadingProvider = ({ children }) => {
  const [show, setShow] = useState(true);
  const hide = useCallback(() => {
    setShow(false);
  }, [setShow]);
  return (
    <>
      <Context.Provider value={hide}>{children}</Context.Provider>
      {show && <LoadingOverlay />}
    </>
  );
};

WaterfallLoadingProvider.propTypes = {
  children: PropTypes.node.isRequired
};

// Helper component that hides the WaterfallLoading
export const WaterfallLoadingHider = () => {
  const hide = useContext(Context);
  useLayoutEffect(() => hide(), [hide]);
  return null;
};
